import styled from "styled-components";

export const Styled = styled.div`
  & {
    height: 100%;
  }

  .rpv-toolbar__right {
    .rpv-core__display--hidden {
      display: none !important;
      &:first-child {
        display: block !important;
      }
    }
  }
`;
